import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CountryModel } from 'src/app/shared/models/country.model';
import { CountryService } from 'src/app/core/services/country.service';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-lading-home-office',
  templateUrl: './landing-home-office.component.html',
  styleUrls: ['./landing-home-office.component.scss']
})

export class LandingHomeOfficeComponent implements OnInit {
  formGroup: FormGroup;

  data: any;

  countrys: Array<CountryModel>;

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private countryService: CountryService,
    private formBuilder: FormBuilder,
    private usuarioService: UsuarioService,
    private modalService: NgbModal,
    private gaService: GoogleAnalyticsService
  ) {
    this.carregarFormGroup();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.carregarListaDePaises();
    });
  }

  ngOnInit() {
    this.carregarDados();
    this.carregarListaDePaises();
  }


  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formEmpresa: new FormControl('', Validators.required),
        formNome: new FormControl('', Validators.required),
        formEmail: new FormControl('', Validators.compose(
          [
            Validators.required,
            Validators.email
          ]
        )),
        formTelefone: new FormControl('', [Validators.required, Validators.maxLength(18)]),
        formPais: new FormControl('', Validators.required),
        formUsuario: new FormControl('', Validators.required),
        formComoConheceu: new FormControl('')
      }
    );
  }

  carregarDados() {
    this.translate.get('LANDING_HOME_OFFICE').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
      this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
      this.gaService.pageView(this.router.url);
    });
  }

carregarListaDePaises() {
  this.countryService.carregarListaDePaises()
    .subscribe(
      res => {
        this.countrys = res;
      }
    );
}

onSubmit() {
  this.usuarioService.cadastrarUsuarioTeste(
    this.formGroup.get('formNome').value,
    this.formGroup.get('formEmail').value,
    this.formGroup.get('formUsuario').value,
    this.formGroup.get('formTelefone').value,
    this.formGroup.get('formEmpresa').value,
    this.formGroup.get('formPais').value,
    this.formGroup.get('formComoConheceu').value
  )
    .subscribe(
      res => {
        let message;
        if (res != null) {
          message = res;
        } else {
          message = this.data.CADASTRO.MENSAGEM_SUCESSO;
        }
        const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
        modalRef.componentInstance.message = message;
        this.formGroup.reset();
      },
      err => {
        let message;
        if (err != null && err.status !== 200) {
          if (err.error != null) {
            message = err.error;
          } else {
            message = this.data.CADASTRO.MENSAGEM_ERRO;
          }
          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = message;
        } else {
          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = this.data.CADASTRO.MENSAGEM_SUCESSO;
        }
        this.formGroup.reset();
      }
    );
}

}
